export const shouldLoad = () => document.querySelector('[data-controller="my-content-item-groups"]') !== undefined;
